// here, we will write reducer functions in this file, this file is redux store
// redux action 3, created the action in the reducer function with switch action type
import * as ActionTypes from './ActionTypes';
// fetch 4, added actions to the thunk
export const Comments = (state = {
        errMess: null,
        comments: []
    }, action) => {
            switch(action.type) {
                case ActionTypes.ADD_COMMENTS:
                    return {...state, isLoading: false, errMess: null, comments: action.payload}
            
                case ActionTypes.COMMENTS_FAILED:
                    return {...state, isLoading: false, errMess: action.payload, comments: []}
                
                case ActionTypes.ADD_COMMENT:
                    var comment = action.payload;
                    // comment.id is generated by redux store and server itself
                    return {...state, comments: state.comments.concat(comment)}
                default:
                    return state;
        }
}
